import { render, staticRenderFns } from "./VehicleHero.vue?vue&type=template&id=2cba445e&scoped=true"
import script from "./VehicleHero.vue?vue&type=script&lang=js"
export * from "./VehicleHero.vue?vue&type=script&lang=js"
import style0 from "./VehicleHero.vue?vue&type=style&index=0&id=2cba445e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cba445e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SocialShareButtons: require('/app/components/SocialShareButtons.vue').default})
